const appEnv = process.env.APP_ENV ?? 'development';
const platformHost = process.env.API_URL_PLATFORM ?? 'http://localhost:6006';
const beHost = process.env.API_URL_BE ?? 'http://localhost:4000';

export { appEnv, platformHost, beHost };
